if (!customElements.get('melco-recently-viewed')) {
  customElements.define('melco-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.hidden = true;
      const grid = this.querySelector('[data-recent-grid]');
      if (!grid) return;
      grid.replaceChildren();
      const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
      let history = [];
      try {
        const stored = JSON.parse(sessionStorage.getItem('melco.recently-viewed.v1') || '[]');
        if (Array.isArray(stored)) history = [...new Set(stored.filter(validHandle))].slice(0, 8);
      } catch { /* History is optional; malformed or unavailable storage is ignored. */ }
      const current = this.dataset.current;
      const handles = history.filter(handle => handle !== current).slice(0, 4);
      if (validHandle(current)) {
        try { sessionStorage.setItem('melco.recently-viewed.v1', JSON.stringify([current, ...history.filter(handle => handle !== current)].slice(0, 8))); } catch { /* Continue without persistence. */ }
      }
      if (!handles.length) return;
      try {
        const root = new URL(this.dataset.root || '/', window.location.origin);
        if (root.origin !== window.location.origin) return;
        root.pathname = root.pathname.replace(/\/+$/, '') + '/';
        const cards = await Promise.all(handles.map(async handle => {
          try {
            const url = new URL(`${root.pathname}products/${encodeURIComponent(handle)}`, root.origin);
            url.searchParams.set('section_id', 'melco-recent-card');
            const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
            if (!response.ok) return null;
            const markup = await response.text();
            const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
            const card = documentFragment.querySelector('[data-melco-recent-card]');
            if (!card) return null;
            card.querySelectorAll('script').forEach(script => script.remove());
            return card;
          } catch { return null; }
        }));
        if (controller.signal.aborted || this.controller !== controller || !this.isConnected) return;
        cards.filter(Boolean).forEach(card => grid.appendChild(document.importNode(card, true)));
        this.hidden = grid.children.length === 0;
      } catch { /* A failed optional history never blocks browsing or the cart. */ }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
